import { clsx } from 'clsx';
import { useSearchParams, NavLink } from 'react-router-dom';
import { useFilteredDocuments, useDocumentsByCategory } from './utils/hooks';
import { useLegalEntityRegions } from '../../hooks/useUser';

export const CertificatesSidebar = () => {
  const { categories, types, selectedRegion } = useFilteredDocuments();
  const { documentsByCategory } = useDocumentsByCategory();
  const regions = useLegalEntityRegions();
  const [searchParams] = useSearchParams();
  const categoryId = searchParams.get('category');

  const typeMap = Object.fromEntries(types.map((type) => [type.id, type]));

  return (
    <aside className="w-80 overflow-y-auto">
      {selectedRegion && (
        <h2 className="px-4 pt-6 text-lg font-semibold text-gray-900">
          {selectedRegion.name}
        </h2>
      )}
      <nav>
        <ul className="ml-4 mt-6 pr-4">
          {categories.map((category) => {
            const docs = documentsByCategory[category.id];
            if (!docs || docs.length === 0) return null;

            return (
              <li key={category.id} className="mb-6">
                {!categoryId && (
                  <div className="mb-2 px-2 text-xs font-semibold uppercase tracking-wide text-gray-500">
                    {category.name}
                  </div>
                )}

                <div className="rounded border border-gray-200 bg-white">
                  {docs.map((doc, index) => {
                    const type = typeMap[doc.document_type_id];

                    return (
                      <NavLink
                        key={index}
                        to={{
                          pathname: `/documents/${doc.id}`,
                          search: searchParams.toString(),
                        }}
                        className={({ isActive }) =>
                          clsx(
                            'block px-4 py-3 transition-colors',
                            index !== 0 && 'border-t border-gray-200',
                            isActive
                              ? 'bg-teal-100 '
                              : 'text-gray-900 hover:bg-gray-50',
                          )
                        }
                      >
                        {({ isActive }) => (
                          <>
                            <div className="flex items-center gap-2">
                              <span
                                className={clsx(
                                  'flex-1 overflow-hidden truncate whitespace-nowrap text-base font-medium',
                                  isActive ? 'text-gray-900' : 'text-zinc-800',
                                )}
                                title={type.name.trim()}
                              >
                                {type.name.trim()}
                              </span>
                            </div>

                            {type.description && (
                              <div className="mt-0.5 overflow-hidden truncate whitespace-nowrap text-sm text-zinc-600">
                                {type.description.trim()}
                              </div>
                            )}

                            {doc.region_code && (
                              <div className="mt-0.5 overflow-hidden truncate whitespace-nowrap text-sm text-zinc-600">
                                {
                                  regions.find(
                                    (r) => r.code === doc.region_code,
                                  )?.name
                                }
                              </div>
                            )}
                          </>
                        )}
                      </NavLink>
                    );
                  })}
                </div>
              </li>
            );
          })}
        </ul>
      </nav>
    </aside>
  );
};
